var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-input-modal',{ref:"input",attrs:{"byDefault":_vm.getData(),"student":_vm.student,"title":_vm.title,"options":_vm.items},on:{"selectedElement":_vm.propagateChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03663893","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaryElements/FuitOrYogurt.vue
// module id = 241
// module chunks = 1